import React from "react";
import { Parah } from "../ContentsStyles";

export const handleEmailClick = () => {
  const email = "info@talentsexplore.com";
  const subject = "Hello";
  const body = "Just wanted to say hi!";

  const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;

  window.location.href = mailtoLink;
};

const TAC_10 = () => {
  return (
    <>
      <Parah id="contactUs">
        You can contact us here:{" "}
        <button
          onClick={handleEmailClick}
          style={{
            color: "#ff2146f0",
            background: "none",
            border: "none",
            padding: 0,
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          Share your feedback
        </button>
      </Parah>
      <Parah>
        In some countries, the law requires us to provide additional regulatory
        information and/or contact points within the country, even though we may
        not be physically present there.
      </Parah>
    </>
  );
};

export default TAC_10;
